/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import {LabelMedium} from 'baseui/typography'
import React from 'react'

const PageSectionTitle = ({sectionTitle = ''}) => (
  <LabelMedium
    overrides={{
      Block: {
        style: ({$theme}) => ({
          color: $theme.colors.mono1000,
          marginBottom: $theme.sizing.scale400,
        }),
      },
    }}
  >
    {sectionTitle}
  </LabelMedium>
)

export default PageSectionTitle
